var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-lay-out"}},[_c('keep-alive',[(_vm.$route.meta.cache)?_c('router-view',{staticClass:"lay-out-window"}):_vm._e()],1),(!_vm.$route.meta.cache)?_c('router-view',{staticClass:"lay-out-window"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }